module.exports = __webpack_public_path__ + "img/LY.bea7362c.svg";